module.exports = __webpack_public_path__ + "static/media/thumbs-down.0051e26d.svg";